<template>
  <layout :operation="'engineering-center'"></layout>
</template>

<script>
import Layout from "@/views/front/jsf35/operations";

export default {
  name: "EngineeringCenter",
  components: {
    Layout,
  },
};
</script>

<style lang="scss" scoped></style>
